import Tooltip from "components/Tooltip";

import "./style.scss";

const Input = ({
    label,
    isSelect,
    selectOptions,
    subText,
    onChange,
    min,
    max,
    tooltipText,
    withSlider = false,
    isToolTipFullWidth = false,
    ...inputProps
}) => {
    const { type } = inputProps;

    const onBlur = (e) => {
        let { value, name } = e.target;

        if (min !== undefined && Number(value) < min) {
            value = min;
        }

        if (max !== undefined && Number(value) > max) {
            value = max;
        }

        onChange(name, type === "number" ? Number(value) : value);
    };

    return (
        <div className="input-container">
            {label && <label className="input-label">{label}</label>}
            <div className="input-wrapper">
                <Tooltip
                    tooltipText={tooltipText}
                    iconAdjustemntMaring={withSlider ? { marginBottom: "25px" } : {}}
                    isToolTipFullWidth={isToolTipFullWidth}
                >
                    {/* {isSelect ? (
            <select
              className="input"
              {...inputProps}
              onChange={(e) => onChange(e.target.name, e.target.value)}
            >
              {selectOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select> */}

                    {isSelect ? (
                        <select
                            className="input"
                            onChange={(e) => onChange(e.target.name, e.target.value)}
                            {...inputProps}
                        >
                            {selectOptions.map((option, i) =>
                                option.options ? (
                                    // ✅ This is an optgroup
                                    <optgroup key={i} label={option.label}>
                                        {option.options.map((opt) => (
                                            <option key={opt.value} value={opt.value}>
                                                {opt.label}
                                            </option>
                                        ))}
                                    </optgroup>
                                ) : (
                                    // ✅ This is a normal option
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ),
                            )}
                        </select>
                    ) : (
                        <div
                            style={
                                withSlider
                                    ? {
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "10px",
                                          width: "100%",
                                      }
                                    : { width: "100%" }
                            }
                        >
                            <input
                                className="input"
                                {...inputProps}
                                onChange={(e) =>
                                    onChange(e.target.name, type === "checkbox" ? e.target.checked : e.target.value)
                                }
                                onBlur={(e) => onBlur(e)}
                            />
                            {withSlider && (
                                <input
                                    className="input-slider"
                                    type="range"
                                    min={min}
                                    max={max}
                                    step={inputProps.step}
                                    value={inputProps.value}
                                    onChangeCapture={(e) => onChange(e.target.name, e.target.value)}
                                    name={inputProps.name}
                                />
                            )}
                        </div>
                    )}
                </Tooltip>
                <span className="input-sublabel">{subText}</span>
            </div>
        </div>
    );
};

export default Input;
